import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { selectOptions } from '../ActiveGame/selectors';
import { optionReason } from '../ActiveGame/options';
import ConfirmButton from '../ConfirmButton';
import { Button, Muted } from '../Controls';
import { discardFromPlay } from './actions';
import { selectDiscardingFromPlay } from './selectors';

/**
 * Clefairy Doll: "At any time during your turn before your attack, you may discard Clefairy Doll." Shown only for a
 * Trainer in play, greyed out with the server's reason when it can't be discarded now.
 */
const DiscardFromPlayButton = ({ at, name }) => {
  const dispatch = useDispatch();
  const options = useSelector(selectOptions);
  const discarding = useSelector(selectDiscardingFromPlay);
  const option = options && options.getIn(['discard_in_play', String(at)]);

  if (option === undefined) {
    return null;
  }

  if (option !== true) {
    return (
      <>
        <Button disabled $block>Discard {name}</Button>
        <Muted>{optionReason(option)}</Muted>
      </>
    );
  }

  return (
    <ConfirmButton
      onConfirm={() => dispatch(discardFromPlay(at))}
      disabled={discarding}
      prompt={`Discard ${name}? It gives your opponent no prize card.`}
    >
      Discard {name}
    </ConfirmButton>
  );
};

DiscardFromPlayButton.propTypes = {
  at: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
};

export default DiscardFromPlayButton;
